import { useEffect, useRef } from 'react';

import { TabbedModuleSettings } from 'Deer/components/TabbedModuleSettings/TabbedModuleSettings';
import { getApplicableL2CompanyModules } from 'Deer/components/navigation/secondary/Company/CompanyModules';
import { STATIC_COHORTS } from 'Deer/constants/cohorts';
import { EngagementIntentDropdown } from 'Deer/intent/Engagement/components/EngagementIntentDropdown';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch } from 'react-redux';
import { setSelectedView } from 'reducers/viewsSlice';

const EngagementSettings = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);
  const { moduleName } = useOrganisationSettings();
  const applicableL2CompanyModules = getApplicableL2CompanyModules(moduleName) ?? [];

  useEffect(() => {
    dispatch(setSelectedView(STATIC_COHORTS.company));
    return () => {
      dispatch(setSelectedView({}));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      Filters={
        <EngagementIntentDropdown
          showKebabMenu={false}
          gridRef={gridRef}
          breadcrumbs={{
            items: [
              {
                label: 'Company',
                to: applicableL2CompanyModules[0]?.value,
              },
            ],
            page: {
              label: 'Engagement',
              to: '',
            },
          }}
        />
      }
    >
      <TabbedModuleSettings />
    </Layout>
  );
};

export { EngagementSettings };
